"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDatePayload = exports.expandTournamentsAndEventsState = void 0;
exports.createResultsReq = createResultsReq;
exports.processSportIdsForResults = processSportIdsForResults;
const values_1 = __importDefault(require("lodash/values"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const dayjs_1 = __importDefault(require("dayjs"));
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../CommonDataProvider/selectors");
const utils_1 = require("../ConfigProvider/utils");
const types_1 = require("../ConfigProvider/types");
const saga_1 = require("../ConfigProvider/saga");
const constants_1 = require("./constants");
const expandTournamentsAndEventsState = (state) => {
    const currentShownResults = (0, values_1.default)(state.data.resultsBySportAndTournament[state.filters.currentSportId]);
    const tournamentsIds = currentShownResults.map((result) => result.tournament.id);
    const eventsIds = (0, flatten_1.default)(currentShownResults.map((result) => result.events.map(({ id }) => id)));
    state.filters.expandedTournamentsStat = tournamentsIds;
    state.filters.expandedEventsStat = eventsIds;
};
exports.expandTournamentsAndEventsState = expandTournamentsAndEventsState;
function* createResultsReq(reqData, isGenericSportsEnabled) {
    const { date, sportId, pageKey } = reqData;
    const datePayload = (0, exports.createDatePayload)(date);
    const isNewResultsEndpoint = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_RESULTS_ENDPOINT);
    const baseRequest = {
        ...reqData,
        ...datePayload,
        sportIds: isNewResultsEndpoint && sportId ? [sportId] : undefined,
        sportId: !isNewResultsEndpoint ? sportId : undefined,
        pageKey: isNewResultsEndpoint && pageKey ? pageKey : undefined,
    };
    const enrichedRequest = yield (0, effects_1.call)(processSportIdsForResults, baseRequest, isGenericSportsEnabled, isNewResultsEndpoint);
    return enrichedRequest;
}
function* processSportIdsForResults(reqData, isGenericSportsEnabled, isNewResultsEndpoint) {
    var _a;
    if (isNewResultsEndpoint && ((_a = reqData.sportIds) === null || _a === void 0 ? void 0 : _a.length)) {
        const expandedSportIds = yield (0, effects_1.select)((state) => reqData.sportIds.flatMap((id) => (0, selectors_1.selectChildrenSportIds)(state, id)));
        if (expandedSportIds.length) {
            return {
                ...reqData,
                sportIds: [...new Set([...reqData.sportIds, ...expandedSportIds])],
            };
        }
    }
    else if (reqData.sportId && isGenericSportsEnabled) {
        const childrenSportIds = yield (0, effects_1.select)((state) => (0, selectors_1.selectChildrenSportIds)(state, reqData.sportId));
        if (childrenSportIds.length) {
            return {
                ...reqData,
                sportId: undefined,
                sportIds: childrenSportIds,
            };
        }
    }
    return reqData;
}
const createDatePayload = (date) => {
    const isNewResultsEndpoint = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.NEW_RESULTS_ENDPOINT);
    return isNewResultsEndpoint
        ? {
            scheduledFrom: (0, dayjs_1.default)(date).startOf('day').format(constants_1.DATE_FORMAT),
            scheduledTo: (0, dayjs_1.default)(date).endOf('day').format(constants_1.DATE_FORMAT),
        }
        : {
            date: (0, dayjs_1.default)(date).format(constants_1.DATE_FORMAT),
        };
};
exports.createDatePayload = createDatePayload;
//# sourceMappingURL=utils.js.map